import { RubenProfileLicenseDto, RubenProfileLicenseItemDto, RubenProjectLicenseDto, RubenProjectLicenseItemDto, RubenProjectLicenseRenderedDto } from "types";
import { request } from "utils/ajax";


export function createRubenProfileLicense(profileId: number, license: RubenProfileLicenseDto): Promise<RubenProfileLicenseDto> {
    return request(`api/license/ruben/profile/${profileId}`, {
        method: 'PUT',
        body: license,
        json: true,
    }).then((x) => x.json());
}

export function getRubenProfileLicense(profileId: number): Promise<RubenProfileLicenseDto> {
    return request(`api/license/ruben/profile/${profileId}`).then((x) => x.json());
}

export function updateRubenProfileLicense(profileId: number, license: RubenProfileLicenseDto): Promise<RubenProfileLicenseDto> {
    return request(`api/license/ruben/profile/${profileId}`, {
        method: 'POST',
        body: license,
        json: true,
    }).then((x) => x.json());
}

export function setRubenProfileLicenseItem(profileId: number, item: RubenProfileLicenseItemDto): Promise<RubenProfileLicenseItemDto> {
    return request(`api/license/ruben/profile/${profileId}/item`, {
        method: 'POST',
        body: item,
        json: true,
    }).then((x) => x.json());
}

// Project Endpoints

export function createRubenProjectLicense(projectId: number, license: RubenProjectLicenseDto): Promise<RubenProjectLicenseRenderedDto> {
    return request(`api/license/ruben/project/${projectId}`, {
        method: 'PUT',
        body: license,
        json: true,
    }).then((x) => x.json());
}

export function getRubenProjectLicense(projectId: number): Promise<RubenProjectLicenseRenderedDto> {
    return request(`api/license/ruben/project/${projectId}`).then((x) => x.json());
}

export function updateRubenProjectLicense(projectId: number, license: RubenProjectLicenseDto): Promise<RubenProjectLicenseRenderedDto> {
    return request(`api/license/ruben/project/${projectId}`, {
        method: 'POST',
        body: license,
        json: true,
    }).then((x) => x.json());
}

export function setRubenProjectLicenseItem(projectId: number, item: RubenProjectLicenseItemDto): Promise<RubenProjectLicenseRenderedDto> {
    return request(`api/license/ruben/project/${projectId}/item`, {
        method: 'POST',
        body: item,
        json: true,
    }).then((x) => x.json());
}